import CommentModel from '@models/Project/Comment.model'
import { action, extendObservable } from 'mobx'
import { complianceBreachApi, deleteComment, getAllComments, sendComment } from '@atheneum/api'

class CommentStore {
  constructor () {
    extendObservable(this, {
      loading: false,
      error: null,
      comments: []
    })
  }

  load = action((id, model, markAllAsSeen) => {
    this.comments.clear()
    this.error = null
    this.loading = true

    if (!Number(id)) {
      this.comments = []
      this.loading = false
    } else {
      return getAllComments(model, id, Boolean(markAllAsSeen))
        .then(commentList => {
          complianceBreachApi.getComments(id)
            .then(sherlockComments => {
              const comments = commentList
                .concat(sherlockComments)
                .map(c => new CommentModel(c))
              this.comments.replace(comments)
              this.loading = false
            })
            .catch(error => {
              this.loading = false
              this.error = error
            })
        })
        .catch(error => {
          this.loading = false
          this.error = error
        })
    }
  })

  create = action(async (id, comment, model, markAllAsSeen) => {
    const commentData = await sendComment(
      model,
      id,
      comment,
      Boolean(markAllAsSeen)
    )
    this.comments.push(new CommentModel(commentData))
  })

  delete = action((id, modelId, model) =>
    deleteComment(model, id).then(() => this.load(modelId, model))
  )
}

export default CommentStore
